/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d40b99453dc3bdb802ab78b4560ab56>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */

const createEventPayload = (eventKey, ...[attributes]) => {
  const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
  if (eventType === 'screen') {
    return {
      eventType,
      name: actionSubject,
      action: 'viewed',
      attributes: attributes
    };
  }
  return {
    eventType,
    actionSubject,
    action,
    actionSubjectId,
    attributes: attributes
  };
};
export default createEventPayload;